import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-upload', 'upload', 'Upload');
Labels.set('ui-upload', 'uploadFiles', 'Upload files');
Labels.set('ui-upload', 'clear', 'Remove file');
